"use client";

/**
 * useScrollSpy Hook
 *
 * IntersectionObserver-based scroll spy for Table of Contents.
 * Tracks which heading is currently in view.
 */
import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useCallback } from "react";
import { TOCItem } from "@/types/blog";
interface UseScrollSpyOptions {
  headings: TOCItem[];
  rootMargin?: string;
  threshold?: number;
}
export function useScrollSpy(t0) {
  const $ = _c(6);
  const {
    headings,
    rootMargin: t1,
    threshold: t2
  } = t0;
  const rootMargin = t1 === undefined ? "0px 0px -75% 0px" : t1;
  const threshold = t2 === undefined ? 0 : t2;
  const [activeId, setActiveId] = useState("");
  let t3;
  let t4;
  if ($[0] !== activeId || $[1] !== headings || $[2] !== rootMargin || $[3] !== threshold) {
    t3 = () => {
      if (headings.length === 0) {
        return;
      }
      if (!activeId && headings[0]) {
        setActiveId(headings[0].id);
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      }, {
        rootMargin,
        threshold
      });
      headings.forEach(t5 => {
        const {
          id
        } = t5;
        const element = document.getElementById(id);
        if (element) {
          observer.observe(element);
        }
      });
      return () => observer.disconnect();
    };
    t4 = [headings, rootMargin, threshold, activeId];
    $[0] = activeId;
    $[1] = headings;
    $[2] = rootMargin;
    $[3] = threshold;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return activeId;
}

/**
 * Smooth scroll to a heading with offset for fixed header
 */
export function scrollToHeading(id: string, offset: number = 120): void {
  const element = document.getElementById(id);
  if (element) {
    const top = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top,
      behavior: "smooth"
    });
  }
}